import { render, staticRenderFns } from "./listPrivateGroup.vue?vue&type=template&id=4fbf135b&"
import script from "./listPrivateGroup.vue?vue&type=script&lang=js&"
export * from "./listPrivateGroup.vue?vue&type=script&lang=js&"
import style0 from "./listPrivateGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports